import _ from 'underscore';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import classNames from 'classnames';
import jsdata from '@bingads-webui-component-legacy/js-data-campaign/index';
import edmCampaign from '@bingads-webui-component-legacy/edm-campaign/index';

import { NewAdStrengthScore } from './new-ad-strength-score';
import { getStrengthIcon, newGenerateSuggestion } from './ad-strength-helper';
import { getAdStrengthTopGridStyles } from './styles';

const getDefaultAsset = (num) => {
  const assetList = new Array(num);
  const emptyAsset= {
    Asset: {
      '@odata.type': '#Model.TextAsset',
      AssetType: 'Text',
      Name: null,
      Text: '',
    },
    PinnedField: 'None',
  };
  assetList.fill(emptyAsset);
  return assetList;
};

const fetchAdStrength = (ad, scope) => {
  const { campaignId, adGroupId } = scope.values;
  const params = {
    query: {
      entitySet: edmCampaign.currentAccount
        .Campaigns.$withKey(campaignId)
        .AdGroups.$withKey(adGroupId)
        .Ads['Default.GetAdStrengthAndActionItems']
        .$call({
          ad: {
            '@odata.type': '#Model.ResponsiveSearchAd',
            Type: 'ResponsiveSearch',
            adId: ad.Id,
            Headlines: ad.Headlines || getDefaultAsset(5),
            Descriptions: ad.Descriptions || getDefaultAsset(2),
          },
        })
        .toJSON(),
    },
  };
  const options = {
    cacheResponse: false,
  };
  return jsdata.Ad.findAll(params, options);
};

export function AdStrengthTopGrid(props) {
  const {
    adItem,
    scope,
    i18n,
  } = props;
  const [adStrength, setAdStrength] = useState();
  const [actionItems, setActionItems] = useState([]);
  const [priority, setPriority] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const iconName = getStrengthIcon(adStrength);
  const classes = useDefaultStyles(getAdStrengthTopGridStyles);
  useEffect(() => {
    const rawActionItems = Object.keys(actionItems).map((key, index) => newGenerateSuggestion({
      i18n,
      actionItem: key,
      xValue: actionItems[key],
      priority: priority[index],
    }));
    const sortedSuggestions=_.sortBy(rawActionItems, suggestion => suggestion.priority || 100);

    setSuggestions(sortedSuggestions);
  }, [actionItems, adStrength, i18n, priority]);

  useEffect(() => {
    if (adItem) {
      const { Headlines, Descriptions } = adItem;
      const notEmptyHeadlines = Headlines && Headlines.filter(item => item.Asset.Text !== '');
      const notEmptyDescriptions = Descriptions && Descriptions.filter(item => item.Asset.Text !== '');
      fetchAdStrength({ Headlines: notEmptyHeadlines, Descriptions: notEmptyDescriptions, adId: adItem.Id }, scope).then((response) => {
        const {
          Strength,
          ActionItemsV2,
          Priorities,
        } = response;

        setAdStrength(Strength);
        setActionItems(JSON.parse(ActionItemsV2));
        setPriority(Priorities || []);
      });
    }
  }, [adItem, scope]);

  return (
    <React.Fragment>
      { adStrength &&
      <div className={classNames('ad-strength-container', classes.container)}>
        <div className="ad-strengh-panel-title">Ad Strength</div>
        <div className="ad-strength-content">
          <div className="ad-strength-title">
            <FontIcon
              iconName={iconName}
              className={`icon ${adStrength}`}
            />
            {i18n.getString(_TL_(`${adStrength} Performance`))}
          </div>
          <NewAdStrengthScore
            strength={adStrength}
          />
          { adStrength !== 'Excellent' &&
          <div className="ad-strength-suggestions">
            <ul className="ad-strength-actions">
              {_.map(suggestions, suggestion => (
                <li>
                  <FontIcon
                    iconName="CRMCustomerInsightsApp"
                    className="suggestion-icon"
                  />
                  {suggestion.suggestion}
                </li>
                ))}
            </ul>
          </div>
               }
        </div>
      </div>
      }
    </React.Fragment>
  );
}

AdStrengthTopGrid.propTypes = {
  adItem: PropTypes.shape({
    Headlines: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    Descriptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
  scope: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};

